import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import IModbusDeviceSummaryDTO from "../../../shared/oversight-core/dtos/response-dtos/modbus-device-summary-dto";
import { EDateTypes } from "../../../shared/oversight-core/enums/date-types";
import { RootState } from "../../store";

interface IManufacturedDevice {
  isUpdateCurrentData: boolean;
}

interface IMobBusDashboardFilters {
  selectedDate: Date;
  selectedDateType: EDateTypes;
}

const defaultFilters: IMobBusDashboardFilters &
  IManufacturedDevice &
  IModbusDeviceSummaryDTO = {
  partitionKey: "",
  iotDeviceId: "",
  deviceId: 0,
  deviceName: "",
  model: "",
  spaceId: "",
  spaceClusterId: "",
  lastSeen: "",
  isDefined: false,
  registerDefinitionId: "",
  selectedDate: new Date(),
  selectedDateType: EDateTypes.DAILY,
  isUpdateCurrentData: false,
};

export const mobBusSlice = createSlice({
  name: "mobBus",
  initialState: { ...defaultFilters },
  reducers: {
    setSelectedModBusDevice: (
      state,
      action: PayloadAction<IModbusDeviceSummaryDTO>,
    ) => {
      state.partitionKey = action.payload.partitionKey;
      state.iotDeviceId = action.payload.iotDeviceId;
      state.deviceId = action.payload.deviceId;
      state.deviceName = action.payload.deviceName;
      state.model = action.payload.model;
      state.spaceId = action.payload.spaceId;
      state.spaceClusterId = action.payload.spaceClusterId;
      state.lastSeen = action.payload.lastSeen;
      state.isDefined = action.payload.isDefined;
      state.registerDefinitionId = action.payload.registerDefinitionId;
    },
    setModBusDashboardFilters: (
      state,
      action: PayloadAction<IMobBusDashboardFilters>,
    ) => {
      state.selectedDate = action.payload.selectedDate;
      state.selectedDateType = action.payload.selectedDateType;
    },
    setIsUpdateCurrentManufacturedData: (
      state,
      action: PayloadAction<IManufacturedDevice>,
    ) => {
      state.isUpdateCurrentData = action.payload.isUpdateCurrentData;
    },
    setModBusIsDefined: (state, action: PayloadAction<boolean>) => {
      state.isDefined = action.payload;
    },
  },
});

export const {
  setSelectedModBusDevice,
  setModBusDashboardFilters,
  setIsUpdateCurrentManufacturedData,
  setModBusIsDefined,
} = mobBusSlice.actions;

export const selectModBusDevice = (state: RootState) => state.mobBus;
export const selectModBusDashboardFilters = (state: RootState) => state.mobBus;
export const selectIsUpdateCurrentManufacturedData = (state: RootState) =>
  state.mobBus;

export default mobBusSlice.reducer;
